import { Group, Line, Rect } from 'react-konva';
import {
  getBasicBackgroundColor,
  getBasicTextColor,
} from '../../../../core/utils/view';
import { UseGridOperations } from '../../../hooks/useGridOperations';
import { CellPosition } from '../../../types';
import Color from 'tinycolor2';
import { getTextContrastColor } from '../../../helpers/cellView/cellViewHelpers';
import { SheetCommandType } from '../../../types/commands/sheetCommands/sheetCommands';

interface CellCheckboxProps
  extends Pick<UseGridOperations, 'performSheetOperation'> {
  sheetId: string;
  size: number;
  backgroundColor?: string | null;
  color?: string | null;
  width: number;
  height: number;
  x: number;
  y: number;
  position: CellPosition;
  isDarkTheme: boolean;
  isChecked: boolean;
  checkedValue: string;
  uncheckedValue: string;
}

// TODO: Generate Contrast Color for Checkbox If fill is dark generate light color
export default function CellCheckbox({
  size,
  backgroundColor,
  width,
  height,
  x,
  y,
  color,
  isDarkTheme,
  sheetId,
  isChecked,
  position,
  checkedValue,
  uncheckedValue,
  performSheetOperation,
}: // performCellOperation,
CellCheckboxProps) {
  // size = 22 
  // TODO: Include Padding
  const rectX = (width - size) / 2;
  const rectY = (height - size) / 2;

  const strokeWidth = size / 10; // Calculate stroke width based on size

  const tickPoints = [
    rectX + size * 0.2, // x1
    rectY + size * 0.45, // y1 Start point
    rectX + size * 0.45, // x2
    rectY + size * 0.63, // y2 Middle point
    rectX + size * 0.8, // x3
    rectY + size * 0.2, // y3 End point
  ];

  const { primaryColor, secondaryColor } = getTextContrastColor(
    backgroundColor,
    color,
    isDarkTheme
  );
  // const textColor = getBasicTextColor(isDarkTheme);
  // const tickBg = backgroundColor
  //   ? backgroundColor
  //   : getBasicBackgroundColor(isDarkTheme);

  // let checkboxBg = color ? color : textColor;
  // // ? mostReadable(backgroundColor, [ligh]) //getContrastTextColor(backgroundColor)
  // // : textColor;

  // if (!color) {
  //   const color = backgroundColor ?? tickBg;
  //   const light = Color(color).lighten(35);
  //   const dark = Color(color).darken(35);
  //   checkboxBg = Color.mostReadable(color, [light, dark], {
  //     includeFallbackColors: false,
  //   }).toHexString();
  // }

  return (
    <Group x={x} y={y}>
      <Rect
        x={rectX}
        y={rectY}
        height={size}
        width={size}
        strokeWidth={strokeWidth}
        stroke={primaryColor}
        fill={isChecked ? primaryColor : undefined}
        cornerRadius={2}
        onClick={() =>
          performSheetOperation({
            type: SheetCommandType.CellInput,
            position,
            sheetId,
            value: isChecked ? uncheckedValue : checkedValue,
          })
        }
      />
      {isChecked && (
        <Line
          points={tickPoints}
          stroke={secondaryColor}
          strokeWidth={strokeWidth}
          listening={false}
        />
      )}
    </Group>
  );
}
